'use client';

export { default } from './TableFooter';
export { default as tableFooterClasses } from './tableFooterClasses';
export * from './tableFooterClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableFooter/index.js
// module id = 967
// module chunks = 25